<span class="user-inline-view-container container" matTooltipClass="multiline-tooltip" [matTooltip]="tooltip">
  {{user?.firstName}}&nbsp;{{user?.lastName}}
</span>
